export enum DocumentExternalSource {
	SAPHETY_DOCSERVER_EIF = 'SAPHETY.DOCSERVER.EIF',
	SAPHETY_EBP_EIF = 'SAPHETY.EBP.EIF',
	FILE_UPLOAD = 'FILE_UPLOAD',
	API_EXTERNAL_FILE = 'API_EXTERNAL_FILE',
	API_EXTERNAL_SOURCE = 'API_EXTERNAL_SOURCE',
	EXTERNAL_ETL_FILE_INTEGRATION = 'EXTERNAL_ETL_FILE_INTEGRATION',
	SAPHETY_DOC_ARCHIVE_EIF = 'SAPHETY.DOC_ARCHIVE.EIF',
}
